import React, {Fragment, useEffect, useState} from "react";

// components
import NestedTable from "../../../../Common/Legacy/NestedTable";

import FourthLevel from "./FourthLevel";
import {toFixedDate, toMoneyValue} from "../../../../../utils/reactFunctions";
import {CompositeFilterDescriptor} from "@progress/kendo-data-query";
import {objectIsNullOrEmpty} from "../../../../../utils/functions";
import {buildKendoFilter} from "../../../../../utils/kendoUtils";
import {customAxios} from "../../../../../utils/customAxios";
import {BASE_URL} from "../../../../../redux/actions/dashboard/env.variables";

interface Props {
  detailProps: any;
  sellerId: number;
  activeFilters: CompositeFilterDescriptor
  featuresAllowed: string[];
}

export default (props: Props) => {
  const [loading, setLoading] = useState(true);
  const [tableData, setTableData] = useState([]);

  const d = new Date(props.detailProps.dataItem.date);
  const filter = objectIsNullOrEmpty(props.activeFilters)
    ? buildKendoFilter([{
        values: [{
          sellerId: props.sellerId,
        }],
        key: "sellerId"
      }])
    : props.activeFilters;

  const params = {
    query: {
      entity: "orders",
      year: d.getFullYear().toString(),
      month: (d.getMonth() + 1).toString(),
      days: d.getDate().toString(),
    },
    body: {
      filter
    }
  }

  useEffect(() => {
    customAxios(BASE_URL)
        .post("/api/Orders", params)
        .then(res => {
          setTableData(res.data.data);
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
        });
  }, []);

  const tableConfig = (firstColumnName: string) => {
    return [
      {
        headTitle: firstColumnName,
        rowValue: "id",
      },
      {
        headTitle: 'ID ERP',
        rowValue: "erpOrderId",
      },
      {
        headTitle: 'ID SOURCE',
        rowValue: "originOrderId",
      },
      {
        headTitle: 'FECHA',
        rowValue: "orderDate",
        custom: toFixedDate,
      },
      {
        headTitle: 'ORIGEN',
        rowValue: "originSystemCode",
      },
      {
        headTitle: 'ID VENDEDOR',
        rowValue: "sellerId",
      },
      {
        headTitle: 'NOMBRE VENDEDOR',
        rowValue: "sellerName",
      },
      {
        headTitle: 'ID CLIENTE',
        rowValue: "clientId",
      },
      {
        headTitle: 'CLIENTE',
        rowValue: "clientName",
      },
      {
        headTitle: 'CANAL',
        rowValue: "clientChannel",
      },
      {
        headTitle: 'TOTAL NETO',
        rowValue: "totalNetPrice",
        custom: toMoneyValue
      },
      {
        headTitle: 'IVA + IMP INTERNO',
        rowValue: "totalTaxes",
        custom: toMoneyValue
      },
      {
        headTitle: 'PERCEPCIONES',
        rowValue: "totalPerceptions",
        custom: toMoneyValue
      },
      {
        headTitle: 'MONTO',
        rowValue: "total",
        custom: toMoneyValue
      },
      {
        headTitle: 'ESTADO',
        rowValue: "erpState",
      },
      {
        headTitle: 'N° FACTURA',
        rowValue: "invoiceId",
      },
      {
        headTitle: 'TIPO OPERACION AXUM',
        rowValue: "axumOperationType",
      },
    ];
  };

  return (
    <Fragment>
      <NestedTable
        tableConfig={tableConfig('ID AXUM')}
        tableData={tableData}
        loading={loading}
        actions={true}
        detailComponent={(detailProps) => FourthLevel({detailProps, featuresAllowed: props.featuresAllowed})}
        featuresAllowed={props.featuresAllowed}
      />
    </Fragment>
  );
};
